import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import backButton from "assets/images/BackArrowicon.svg";
import ticket from "assets/images/Ticket.svg";

function CommonCardDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleClose = () => {
    props.handleClose();
  };

  const onClickApply = (data) => {
    props?.applyCoupon(data);
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props?.open}
        fullScreen={fullScreen}
        fullWidth
        maxWidth={"sm"}
        className="dialogStyle"
        sx={{ height: '85vh', marginTop: '100px' }}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid md={12} className="width100">
            <DialogTitle
              id="responsive-dialog-title"
              className={`allotDialogHeader ${
                props?.payment && "paymentHeader"
              }`}
            >
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                className="marginTop25 settingDialogMain"
              >
                <Grid item alignItems={"center"}>
                  <Typography
                    className={`font20 fontMedium colorPrimary marginBlock10 alignItem`}
                  >
                    <img
                      src={backButton}
                      alt="back"
                      className="wh24 cursor"
                      onClick={handleClose}
                    />
                    Coupons for you
                  </Typography>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent>
              {props?.couponListData?.length > 0 ? (
                props.couponListData.map((ele, idx) => (
                  <Grid
                    container
                    direction="column"
                    className="borderLightBlue borderRadius20 marginBottom35"
                  >
                    <Grid item container className=" marginBlock10 p10">
                      <Grid item md={1}>
                        <img
                          src={ticket}
                          alt="star"
                          className="wh24 marginRight20"
                        />
                      </Grid>
                      <Grid item md={10}>
                        <Typography className="font18 fontMedium">
                          {ele?.title}
                        </Typography>
                        <Box className="justifyBetween marginBlock10">
                          <Accordion className="boxShadowNone width100">
                          <AccordionSummary
                          className="padding0"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            aria-label="View Details"
                          >
                            <Grid container className="justifyBetween">
                              <Grid item>
                            <Typography className="colorBlue font14 borderGreyRadius">
                            {ele?.couponCode}
                            </Typography>
                            </Grid>
                            <Grid item>
                            <Typography className="font14 colorGrey alignItem">View Details</Typography>
                            </Grid>
                            </Grid>
                          </AccordionSummary>
                            <AccordionDetails key={ele.id} className="padding0">
                              <Box
                                className="borderTopDashed font14 colorGrey"
                                dangerouslySetInnerHTML={{ __html: ele.description }}
                              />
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid item className="borderTopLightBlue justifyCenter">
                      <Button onClick={() => onClickApply(ele)}>
                        Tap To Apply
                      </Button>
                    </Grid>
                  </Grid>
                ))
              ) : (
                <Typography className={`font18 fontNormal colorGrey`}>
                  No coupons available
                </Typography>
              )}
            </DialogContent>
            <DialogActions></DialogActions>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}

export default CommonCardDialog;
